/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Api } from '@axiom/ui';
import { type Tag } from '@axiom/domain';
import { ReadTagsResponseEntity } from './entities/read-tags-response-entity';

import { type ReadTagsResponse } from './dtos/read-tags-response';
import { EnvUtil } from '../../utils/env-util';

class TagApiClass extends Api {
  constructor() {
    super({ domain: EnvUtil.apiEnvoyUrl });
  }

  /*
   * ────────────────────────────────────────────────────────────────────
   *   /tags
   * ────────────────────────────────────────────────────────────────────
   */

  /** Java: TagsController.getAll — GET /tags */
  readTags() {
    return super.read<{ "data": Array<ReadTagsResponse> }>({
      endpoint: '/tags',
      method: 'GET',
      schema: { "data": [ReadTagsResponseEntity] },
    });
  }

  /*
   * ────────────────────────────────────────────────────────────────────
   *   /tags/name/{name}
   * ────────────────────────────────────────────────────────────────────
   */

  /** Java: TagsController.getTags — GET /tags/name/{name} */
  readTagsName({ name }: { name: string }) {
    return super.read<{ "data": Array<ReadTagsResponse> }>({
      endpoint: `/tags/name/${name}`,
      method: 'GET',
      schema: { "data": [ReadTagsResponseEntity] },
    });
  }

  /*
   * ────────────────────────────────────────────────────────────────────
   *   /tags/service/{id}
   * ────────────────────────────────────────────────────────────────────
   */

  /** Java: TagsController.getTag — GET /tags/service/{id} */
  readTagsService({ id }: { id: Tag['id'] }) {
    return super.read<{ "data": ReadTagsResponse }>({
      endpoint: `/tags/service/${id}`,
      method: 'GET',
      schema: { "data": ReadTagsResponseEntity },
    });
  }

  /*
   * ────────────────────────────────────────────────────────────────────
   *   /tags/systemEvents
   * ────────────────────────────────────────────────────────────────────
   */

  /** Java: TagsController.getTags — GET /tags/systemEvents */
  readTagsSystemEvents({ id }: { id: Tag['id'] }) {
    return super.read<{ "data": ReadTagsResponse }>({
      endpoint: '/tags/systemEvents',
      method: 'GET',
      schema: { "data": ReadTagsResponseEntity },
    });
  }
}

export const TagApi = new TagApiClass();
export type { TagApiClass };
